import {AppstoreOutlined, CloseOutlined} from '@ant-design/icons';
import React, {useEffect, useState} from 'react';
import {createStyles} from "antd-style";
import Chat from "@/pages/ISWAN_CHAT/components/Chat/Chat";
import {useChat} from "@/pages/ISWAN_CHAT/hooks/useChat/useChat";
import {ProCard} from "@ant-design/pro-components";
import {Card, Image, Popover, Radio, Space} from "antd";
import {aiToolsList} from "@/pages/ISWAN_APP/Workspace/index.data";
import {useModel} from "@@/exports";
import {AIType} from "@/pages/ISWAN_CHAT/interface";
import {getAiConfig} from "@/components/AiComponent/AiConfig";

interface CopilotProps {
  copilotOpen: boolean;
  setCopilotOpen: (open: boolean) => void;
}


const AiCopilot = (props: CopilotProps) => {
  const {copilotOpen, setCopilotOpen} = props;
  const useCopilotStyle = createStyles(({token, css}) => {
    return {
      copilotChat: css`
        padding: 20px;
        display: flex;
        flex-direction: column;
        background: ${token.colorBgContainer};
        color: ${token.colorText};
        width: ${props.copilotOpen ? '400px' : '0'};
        transition: width 0.3s ease;
        overflow: hidden;
        border-left: ${props.copilotOpen ? `1px solid ${token.colorBorder}` : 'none'};
        height: 100%; // 确保高度继承父容器
      `,
      // chatHeader 样式
      chatHeader: css`
        height: 52px;
        box-sizing: border-box;
        border-bottom: 1px solid ${token.colorBorder};
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px 0 16px;
        min-width: 400px;
      `,
      headerTitle: css`
        font-weight: 600;
        font-size: 15px;
      `,
      headerButton: css`
        font-size: 18px;
      `,
      conversations: css`
        width: 300px;

        .ant-conversations-list {
          padding-inline-start: 0;
        }
      `,
      // chatList 样式
      chatList: css`
        overflow: auto;
        padding-block: 16px;
        flex: 1;
      `,
      chatWelcome: css`
        margin-inline: 16px;
        padding: 12px 16px;
        border-radius: 2px 12px 12px 12px;
        background: ${token.colorBgTextHover};
        margin-bottom: 16px;
      `,
      loadingMessage: css`
        background-image: linear-gradient(90deg, #ff6b23 0%, #af3cb8 31%, #53b6ff 89%);
        background-size: 100% 2px;
        background-repeat: no-repeat;
        background-position: bottom;
      `,
      // chatSend 样式
      chatSend: css`
        padding: 12px;
      `,
      sendAction: css`
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        gap: 8px;
      `,
      speechButton: css`
        font-size: 18px;
        color: ${token.colorText} !important;
      `,
    };
  });
  const {styles} = useCopilotStyle();

  const [open, setOpen] = useState(false);
  const {messages, loading, send, setMessages, setConversationId, stop} = useChat();

  function handleStartNext() {
    setMessages([]);
    setConversationId('');
  }

  const {robot} = useModel('copilot');
  const [aiType, setAiType] = useModel('ISWAN_CHAT.aiType');
  const [showPopver, setShowPopver] = useState(false);

  const [forceUpdate, setForceUpdate] = useState(0);

  // 在 copilotOpen 变化后延迟渲染 Chat
  useEffect(() => {
    const timer = setTimeout(() => {
      setForceUpdate(prev => prev + 1);
    }, 100);
    return () => clearTimeout(timer);
  }, [copilotOpen]);
  return (
    <ProCard
      style={{width: copilotOpen ? 400 : 0}}
      bodyStyle={{padding: 0}}
      title={aiToolsList.find(item => item.key === aiType)?.title}
      headerBordered={true}
      extra={
        <Space>
          <Popover trigger="click" open={showPopver} onOpenChange={(newOpen) => {
            setShowPopver(newOpen);
          }} content={(
            <Space>
              <Card style={{width: 370}} bordered={false}>
                {
                  aiToolsList.map((item: { key: string }) => {
                    return (
                      <Card.Grid
                        onClick={() => {
                          setAiType(item.key as AIType);
                          setShowPopver(false);
                        }}
                        style={{
                          cursor: "pointer", /* 手型指针 */
                          textAlign: "center",
                          width: '25%',
                          border: 'none',
                          padding: '8px',
                          boxShadow: 'none',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center' // 确保内容水平居中
                        }}
                      >
                        <div style={{
                          width: 40,
                          height: 40,
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          background: '#f0f0f0',
                          margin: '0 auto' // 确保圆形容器居中
                        }}>
                          <Image
                            width={24}
                            preview={false}
                            src={item.icon}
                            style={{
                              borderRadius: '50%',
                              display: 'block' // 确保图片在容器中居中
                            }}
                          />
                        </div>
                        <span style={{fontSize: 12, marginTop: 8}}>
                                {item.title.replace(/IYB/g, '')} {/* 移除标题中的IYB */}
                            </span>
                      </Card.Grid>
                    )
                  })
                }
              </Card>
            </Space>
          )} title="请选择一个 AI工具 进行处理">
            <AppstoreOutlined/>
          </Popover>

          <CloseOutlined onClick={() => {
            setCopilotOpen(false);
          }}
          />
        </Space>
      }
    >
      <div
        style={{width: copilotOpen ? 400 : 0}}
        className={styles.copilotChat}
      >
        {/*<Radio.Group*/}
        {/*  style={{*/}
        {/*    display: 'flex',*/}
        {/*    flexDirection: 'column',*/}
        {/*    gap: 8,*/}
        {/*  }}*/}
        {/*  onChange={(e)=>{*/}
        {/*    // setValue(e.target.value);*/}
        {/*  }}*/}
        {/*  // value={value}*/}
        {/*  options={[*/}
        {/*    {value: 1, label: 'Option A'},*/}
        {/*    {value: 2, label: 'Option B'},*/}
        {/*    {value: 3, label: 'Option C'},*/}
        {/*  ]}*/}
        {/*/>*/}
        <Chat
          key={`chat-${forceUpdate}`}
          messages={messages}
          loading={loading}
          onSend={send}
          onSetMessages={setMessages}
          onStartNext={handleStartNext}
          onCancel={stop}
          renderType={aiType === 'Robot' ? 'agent' : 'chat'}
          aiConfig={getAiConfig(aiType,robot) as AiConfigInterface}
          // aiConfig={getAiConfig('Robot',{code:'BOM_DRAW_AI_ROBOT',name:'fsdfsdfds',status:'UNSTART'} as RobotInterface) as AiConfigInterface}
        />
      </div>
    </ProCard>

    // <div
    //   style={{width: copilotOpen ? 400 : 0}}
    //   className={styles.copilotChat}
    // >
    //   <Chat
    //     messages={messages}
    //     loading={loading}
    //     onSend={send}
    //     onSetMessages={setMessages}
    //     onStartNext={handleStartNext}
    //     onCancel={stop}
    //     renderType={'chat'}
    //   />
    // </div>

  )
    ;
};

export default AiCopilot;
